// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lMOz","colBig":"styles_colBig__1de9H","colSmall":"styles_colSmall__Q5fes"};